import _ from 'lodash'

export const GRADATION = 'gradation'
export const BAR = 'bar'

export const ITEM_CLASS = 'cell-config-item-wrapper'

export const closest = (el, fn) => {
  while (el) {
    // 不需要一直找到根 dom
    if (el.classList && el.classList.contains(ITEM_CLASS)) {
      return null
    }

    if (fn(el)) {
      return el
    }

    el = el.parentNode
  }

  return null
}

export const NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT',
}

export const shouldCancelStart = (event) => {
  // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
  const interactiveElements = [
    NodeType.Input,
    NodeType.Textarea,
    NodeType.Select,
    NodeType.Option,
    NodeType.Button,
  ]

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    // Return true to cancel sorting
    return true
  }

  // 阻止删除按钮
  if (event.target.tagName === 'I' && event.target.classList && event.target.classList.contains('condition-remove')) {
    return true
  }

  return !!closest(event.target, el => el.contentEditable === 'true' ||
    (el.classList && (el.classList.contains('dmp-antd-component') || el.classList.contains('ant-dropdown-trigger'))))
}

export const getOperatorByField = (fieldItem) => {
  if (!fieldItem) return ''

  switch (fieldItem.data_type) {
    case '日期':
      if (fieldItem.col_type === 'dim') {
        return 'in'
      } else {
        return '<'
      }
    case '数值':
      if (fieldItem.col_type === 'num') {
        return '<'
      } else {
        return '='
      }
    case '字符串':
    case '枚举':
    default:
      if (fieldItem.col_type === 'dim') {
        return '='
      } else {
        return '<'
      }
  }
}

export const CONFIG_TYPES = [
  {
    name: '单色', value: 'style', icon: require('./images/style.svg'), activeIcon: require('./images/style-active.svg'), special: true,
  },
  {
    name: '图标', value: 'icon', icon: require('./images/icon.svg'), activeIcon: require('./images/icon-active.svg'), special: true,
  }
]

/**
 * 色阶使用参数
 * operator: square 双阶, 3 阶 cube
 * value: 存储值，min/max/数值
 * style.gradation_colors: 存储颜色
 * style.color: 存储字体颜色
 */

export const GRADATION_TYPES = [
  { value: 'square', text: '双色阶' },
  { value: 'cube', text: '三色阶' },
]

/**
 * 条形图使用参数
 * operator: auto 自动计算位置, middle 中点
 * value: 条形图类型，plain 单色，gradation 渐变
 * style.gradation_colors: 存储颜色，【负值，正值】
 * style.color: 存储字体颜色
 */
export const BAR_TYPES = [
  { value: 'auto', text: '自动' },
  { value: 'middle', text: '中点' },
]

export const DIM_OPERATORS = [
  { value: '=', text: '等于' },
  { value: '!=', text: '不等于' },
  { value: 'in', text: '包含' },
  { value: 'not in', text: '不包含' },
  { value: 'is null', text: '为空值' },
  { value: 'is not null', text: '不为空值' }
]

// 数值筛选器可用的操作符
export const NUM_OPERATORS = [
  { value: '=', text: '等于' },
  { value: '!=', text: '不等于' },
  { value: '>', text: '大于' },
  { value: '>=', text: '大于等于' },
  { value: '<', text: '小于' },
  { value: '<=', text: '小于等于' },
  { value: 'between', text: '区间' },
  { value: 'is null', text: '为空值', disableSpecial: true },
  { value: 'is not null', text: '不为空值', disableSpecial: true  }
]

// 时间筛选条件类型
export const DATE_OPERATOR_TYPES = [
  { value: 'dynamic', text: '动态时间段' },
  { value: 'static', text: '静态时间段' },
  { value: 'value', text: '取值' }
]

export const DEFAULT_FONT_ICON = [
  { background: '#FCD7D2', color: '#F0454C', icon: 'default' },
  { color: '#19AB63', background: '#E2F4DF', icon: 'default' },
  { color: '#FFA600', background: '#FFF6D1', icon: 'default' },
  { color: '#2492FC', background: '#DEF3FF', icon: 'default' }
]

export const DEFAULT_ICON_LIST = [
  { icon: 'arrow_up', background: 'transparent', color: '#909399' },
  { icon: 'arrow_down', background: 'transparent', color: '#909399' },
  { icon: 'flag', background: 'transparent', color: '#909399' },
  { icon: 'cross_mark', background: 'transparent', color: '#909399' },
  { icon: 'tick_mark', background: 'transparent', color: '#909399' },
  { icon: 'round', background: 'transparent', color: '#909399' },
  { icon: 'line', background: 'transparent', color: '#909399' },
  { icon: 'triangle_up', background: 'transparent', color: '#909399' },
  { icon: 'triangle_down', background: 'transparent', color: '#909399' }
]

export const DEFAULT_ICON_COLOR = [
  { icon: '', background: '#F0454C', color: '' },
  { icon: '', background: '#2CD781', color: '' },
  { icon: '', background: '#2492FC', color: '' }
]

// operator是否为空值判断类
export const isNullType = operator => operator === 'is null' || operator === 'is not null'
export const isMultiple = operator => operator === 'in' || operator === 'not in'

export const generateConditionOptions = (dims, nums, data) => {
  let fields = []
  dims.forEach((d) => {
    d.col_type = 'dim'
    d.dataset_field_id = d.dim || d.dataset_field_id
  })
  nums.forEach((d) => {
    d.col_type = 'num'
    d.dataset_field_id = d.num
  })

  fields = fields.concat(dims).concat(nums)
  const newData = _.filter(data, d => _.find(fields, f => f.dataset_field_id === d.dataset_field_id && f.col_type === d.col_type)).map((d) => {
    const field = _.find(fields, f => f.dataset_field_id === d.dataset_field_id && f.col_type === d.col_type)
    d.col_name = field.alias
    return d
  })
  return {
    fields,
    data: newData
  }
}
export const _generateFilterOption = (fieldOptions, colName) => {
  let options = Array.isArray(fieldOptions) ? fieldOptions.map((option) => {
    let value = ''
    if (option[colName] === null) return null

    if (option[colName] === '') {
      value = '(空)'
    } else {
      value = option[colName].toString()
    }
    return value
  }).filter(d => d) : []
  options = _.uniq(options)
  return options
}

const LIGHT_THEMES = ['colorful_white', 'gradual_blue']

export const getBarColor = () => {
  const isLightThemes = LIGHT_THEMES.includes(window.__DASHBOARD_THEME)
  return isLightThemes ? 'rgba(32, 36, 55, 1)' : 'rgba(167, 199, 250, 1)'
}

export const getBarLineColor = () => {
  const isLightThemes = LIGHT_THEMES.includes(window.__DASHBOARD_THEME)
  return isLightThemes ? 'rgba(32, 36, 55, 0.5)' : 'rgba(167, 199, 250, 0.5)'
}

export const ICON_ALIGN = [
  { value: 'left', text: '居左' },
  { value: 'right', text: '居右' },
]
